module.exports = __webpack_public_path__ + "static/media/noskheh.b56994ea.png";